import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Userservices from "../../../../services/Userservices";

interface ObjectType {
    Changepassworddata: any[];
}

const initialState: ObjectType = {
    Changepassworddata: [],
}

export const fetchChangepassworddata = createAsyncThunk(
    'fetchchangepassword',
    async (data: any) => {
        const response = await Userservices.Changepassword(data.currentpassword, data.newpassword, JSON.parse(localStorage.getItem("user") as string))
        return response.data
    }
)

export const fetchchangepassworddataslice = createSlice({
    name: 'Changepassworddata',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchChangepassworddata.fulfilled.toString()]: (state, payload) => {
            state.Changepassworddata = payload.payload;
        }
    }
});

export const fetchchangepassworddatareducer = fetchchangepassworddataslice.reducer;